import { BarChart3, LayoutGrid, Monitor, TrendingUp } from 'lucide-react';

export const TABS = [
  { key: 'overview', label: 'Overview', icon: LayoutGrid },
  { key: 'screens', label: 'Screens', icon: Monitor },
  { key: 'progress', label: 'Progress', icon: TrendingUp },
  { key: 'analytics', label: 'Analytics', icon: BarChart3 },
] as const;

export type TabKey = (typeof TABS)[number]['key'];




export const STATUS_STYLE: Record<
  string,
  { bg: string; text: string; dotBg: string }
> = {
  APPROVED: {
    bg: 'bg-[#ECFDF5]',
    text: 'text-[#297857]',
    dotBg: 'bg-[#297857]',
  },
  PENDING: {
    bg: 'bg-[#FFFBEB]',
    text: 'text-[#F59E0B]',
    dotBg: 'bg-[#F59E0B]',
  },
  REJECTED: {
    bg: 'bg-[#FFF7ED]',
    text: 'text-[#CA410C]',
    dotBg: 'bg-[#CA410C]',
  },
  PUBLISHED: {
    bg: 'bg-[#EFF6FF]',
    text: 'text-[#3F4ED8]',
    dotBg: 'bg-[#3F4ED8]',
  },
  CANCELLED: {
    bg: 'bg-[#F9FAFB]',
    text: 'text-[#991B1B]',
    dotBg: 'bg-[#991B1B]',
  },
  CANCEL: {
    bg: 'bg-[#F9FAFB]',
    text: 'text-[#991B1B]',
    dotBg: 'bg-[#991B1B]',
  },
  EXPIRED: {
    bg: 'bg-[#FFF7ED]',
    text: 'text-[#C45530]',
    dotBg: 'bg-[#C45530]',
  },
  LIVE: {
    bg: 'bg-[#ECFDF5]',
    text: 'text-[#297857]',
    dotBg: 'bg-[#297857]',
  },
  PARTIAL_CANCEL: {
    bg: 'bg-[#F5F3FF]',
    text: 'text-[#7C3AED]',
    dotBg: 'bg-[#7C3AED]',
  },
  DRAFT: {
    bg: 'bg-[#F9FAFB]',
    text: 'text-[#9CA3AF]',
    dotBg: 'bg-[#9CA3AF]',
  },
};


export const AGE_COLORS: Record<string, string> = {
  '0-15': '#2DD4BF',
  '18-24': '#8B5CF6',
  '25-34': '#3B82F6',
  '35-44': '#16A34A',
  '45+': '#2563EB',
  '45-100': '#2563EB',
  '45-99': '#2563EB',
};

export const VEHICLE_CATEGORIES = [
  { key: 'car', label: 'Car', color: '#8B5CF6' },
  { key: 'truck', label: 'Truck', color: '#7DD3FC' },
  { key: 'bicycle', label: 'Bicycle', color: '#166534' },
  { key: 'motorcycle', label: 'Motorcycle', color: '#2563EB' },
  { key: 'bus', label: 'Bus', color: '#5EEAD4' },
  { key: 'van', label: 'Van', color: '#FB7185' },
] as const;

export const VEHICLE_EXTRA_COLORS = [
  '#F59E0B',
  '#6366F1',
  '#10B981',
  '#EC4899',
  '#14B8A6',
  '#A855F7',
  '#F97316',
  '#84CC16',
];

export const VEHICLE_SKIP_KEYS = new Set([
  'malecount',
  'femalecount',
  'dwelltime',
  'engagementscore',
  'vehicledistribution',
  'vehicles',
  'agedistribution',
  'success',
  'message',
  'status',
  'data',
  'id',
  '_id',
  'campaignid',
  'total',
  'totalcount',
  'sum',
  'percentage',
  'percent',
]);
